import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useContext } from 'react';
import "../index.css";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';

function ModuleThanks() {
  const [activePage, setActivePage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
  const { Translate } = useContext(ProductContext);

  const stateData = location.state || {};
  const { dayId, unique_day_id, LearningId, screenTitleId, examId, examTypes } = stateData;

  const handleNext = async () => {
    try {
      const token = localStorage.getItem("AuthToken");
      const baseUrl = process.env.REACT_APP_BASE_URL || "https://api.japaking.online";
      const examIdVal = examId || localStorage.getItem("selectedExamId") || localStorage.getItem("examId");
      const resolvedUniqueDayId = unique_day_id || dayId;
      const locLearningId = LearningId || localStorage.getItem("LearningId");
      const locScreenTitleId = screenTitleId || localStorage.getItem("screenTitleId");

      if (token && locLearningId && locScreenTitleId && examIdVal && resolvedUniqueDayId) {
        await fetch(`${baseUrl}/api/user-visits/finish-visit`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            id: resolvedUniqueDayId,
            unique_day_id: resolvedUniqueDayId,
            learning_method_id: locLearningId,
            screen_title_id: locScreenTitleId,
            examId: examIdVal,
          }),
        });
      }
    } catch (error) {
      console.error("Error calling finish-visit in ModuleThanks:", error);
    }

    const examIdVal = examId || localStorage.getItem("selectedExamId") || localStorage.getItem("examId");
    navigate("/new-learning-journey", {
      state: {
        selectedExamId: examIdVal,
        examId: examIdVal,
        examTypes: examTypes || [],
      },
    });
  };

  const handleBack = () => {
    const examIdVal = examId || localStorage.getItem("selectedExamId") || localStorage.getItem("examId");
    navigate("/new-learning-journey", {
      state: {
        selectedExamId: examIdVal,
        examId: examIdVal,
        examTypes: examTypes || [],
      },
    });
  };

  return (
    <div className='Profile_Design_Main_Div_11'>
      <div className='header_inner'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <ArrowBackIosIcon onClick={handleBack} className='icon_1' />
              <h2></h2>  {/* Display the selected day */}
              <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
            </div>
          </div>
        </div>
      </div>

      <div className="thank-you-quiz-container">
        <div className="thank-you-content">
          <h3>やったー！</h3>
          <h2>{Translate?.message?.data?.youveCompletedTheSkit || "You've Completed the Skit!"}</h2>
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/finishquiz.png`}
            className="thank-you-quiz-img"
          />

          <div className="thank-you-quiz-button-group">
            <button onClick={handleNext} className="thank-you-quiz-button">
              {Translate?.message?.data?.next || "Next"}
            </button>
          </div>
        </div>
      </div>

      {/* Footer Section */}
      <Footer />
    </div>
  );
}

export default ModuleThanks;
